var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnergySavingGreen = function SvgEnergySavingGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "energySavingGreen_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#energySavingGreen_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 21a8.68 8.68 0 0 1-3.025-.525 9.09 9.09 0 0 1-2.575-1.45L5.125 20.3c-.2.2-.433.296-.7.287a1.006 1.006 0 0 1-.7-.312c-.2-.2-.3-.438-.3-.712 0-.275.1-.513.3-.713l1.25-1.25a9.048 9.048 0 0 1-1.45-2.588A8.712 8.712 0 0 1 3 12c0-2.5.88-4.625 2.638-6.375S9.517 3 12 3h7c.55 0 1.02.196 1.413.587C20.803 3.98 21 4.45 21 5v7c0 2.483-.875 4.604-2.625 6.363C16.625 20.12 14.5 21 12 21Zm-1.325-4.125 5.175-4.625a.477.477 0 0 0 .15-.537c-.067-.209-.217-.33-.45-.363l-4.05-.4 2.425-3.325a.36.36 0 0 0 .087-.263.487.487 0 0 0-.112-.262.395.395 0 0 0-.575 0l-5.15 4.625a.477.477 0 0 0-.15.537c.067.209.217.33.45.363l4.05.4-2.45 3.325a.502.502 0 0 0-.075.262c0 .092.042.18.125.263A.382.382 0 0 0 10.4 17c.1 0 .192-.042.275-.125Z",
    fill: "#53B741"
  }))));
};
export default SvgEnergySavingGreen;